<template>
    <div>
        <div class="flex-grid a-form-inputs">
            <form @submit.prevent class="m-form">
                <div class="flex-grid__item">
                    <control for="general_damages_psla" label="General Damages (PSLA)" before-after="pound">
                        <input autocomplete="off" v-model.number="generalDamages"
                               name="general_damages_psla"
                               id="general_damages_psla"
                               v-field-control:general_damages_psla.valid="{type:'number', rules:'valid'}"
                               v-on:focus="generalDamages = generalDamages || ''"
                               v-on:blur="generalDamages = generalDamages || 0"
                               v-two-dp
                               type="number"
                               >
                        <span class="a-form-inputs--help" v-if="diseaseType === 'Mesothelioma'">
                            Damages can be calculated using the calculator available
                            <a href="#" @click.prevent="toggleGeneralDamagesPslaModal()">
                                here
                            </a>
                        </span>
                    </control>
                    <control for="Bereavement Award" label="Bereavement Award"
                             before-after="pound"
                             tip-icon="formula"
                             tip-text="Click to view calculation" tip-side="left"
                             tip-width="140"
                             tip-name="bereavement_award"
                             :modal-name="'headsOfLoss_' + uniqueId"
                             :endpoint="'bereavementAward'"
                             :payload="bereavementModalPayload">
                        <input autocomplete="off" :value="findValue('bereavementAward')" type="text" v-two-dp disabled>
                    </control>
                    <control for="funeral_expenses" label="Funeral Expenses" before-after="pound">
                        <input autocomplete="off" v-model.number="funeralExpenses"
                               min="0"
                               class="number"
                               v-field-control:funeral_expenses.valid="{type:'number', rules:'valid'}"
                               v-on:focus="funeralExpenses = funeralExpenses || ''"
                               v-on:blur="funeralExpenses = funeralExpenses || 0"
                               v-two-dp
                               name="funeral_expenses"
                               type="number"
                               @input="calcInterestValue">
                        <control-error :show="$error('funeral_expenses')">
                            Funeral expenses should be greater than &pound;0.00
                        </control-error>
                    </control>
                    <control for="loss_of_spouse"
                            label="Loss of Spouse"
                            before-after="pound"
                            tip-icon="info"
                            tip-text="Click to view information"
                            tip-side="left"
                            tip-width="140"
                            tip-name="loss_of_spouse_award"
                            :modal-name="'lossOfSpouse'">
                        <input autocomplete="off" v-model.number="lossOfSpouse"
                               name="loss_of_spouse"
                               v-on:focus="lossOfSpouse = lossOfSpouse || ''"
                               v-on:blur="lossOfSpouse = lossOfSpouse || 0"
                               min="0"
                               v-two-dp
                               v-field-control:loss_of_spouse.valid="{type:'number', rules:'valid'}"
                               type="number" @input="calcInterestValue">
                        <control-error :show="$error('loss_of_spouse')">
                            Loss of spouse should be greater than &pound;0.00
                        </control-error>
                    </control>
                    <control for="past_cost_of_travel" label="Past Cost of Travel" before-after="pound">
                        <input autocomplete="off" v-model.number="pastCostOfTravel"
                               name="past_cost_of_travel"
                               min="0"
                               v-on:focus="pastCostOfTravel = pastCostOfTravel || ''"
                               v-on:blur="pastCostOfTravel = pastCostOfTravel || 0"
                               v-two-dp
                               v-field-control:past_cost_of_travel.valid="{type:'number', rules:'valid'}"
                               type="number" @input="calcInterestValue">
                        <control-error :show="$error('past_cost_of_travel')">
                            Past cost of travel should be greater than &pound;0.00
                        </control-error>
                    </control>
                    <control for="miscellaneous_costs"
                             label="Miscellaneous - Medication, Appliances, Additional Food & Energy Costs"
                             before-after="pound">
                        <input autocomplete="off" v-model.number="misc"
                               name="miscellaneous_costs"
                               v-on:focus="misc = misc || ''"
                               v-on:blur="misc = misc || 0"
                               min="0"
                               v-two-dp
                               v-field-control:miscellaneous_costs.valid="{type:'number', rules:'valid'}"
                               type="number" @input="calcInterestValue">
                        <control-error :show="$error('miscellaneous_costs')">
                            Miscellaneous should be greater than &pound;0.00
                        </control-error>
                    </control>
                    <div v-for="index in headsOfLoss.length">
                        <head-of-loss @update="updateValid()" :index="index - 1"></head-of-loss>
                    </div>

                    <button class="a-button a-button--no-margin u-r-margin-top-20 u-r-margin-bottom-20" @click="addNewHeadOfLoss">
                        Add Another Head of Loss
                    </button>
                </div>

                <div class="flex-grid__item flex-grid--space-left">
                    <control label="Past Loss of Earnings"
                             tip-text="You have two options to assess the past loss of earnings claim — click the help icon to find out more."
                             tip-icon="info"
                             tip-side="left"
                             tip-width="200"
                             tip-name="pastLossOfEarnings"
                             modalName="pastLossOfEarningsModal">
                        <select id="pastLossOfEarningsType" v-model="pastLossOfEarningsType" required>
                            <option value="" disabled hidden>Please select...</option>
                            <option value="own">Enter your own figure</option>
                            <option value="manual">Detailed calculation</option>
                        </select>
                    </control>
                    <control for="ownPastLossOfEarningsFigure" v-if="pastLossOfEarningsType === 'own'" label="Enter Your Own Figure"
                             before-after="pound">
                        <input autocomplete="off"
                               v-model.number="ownPastLossOfEarningsFigure"
                               v-on:focus="ownPastLossOfEarningsFigure = ownPastLossOfEarningsFigure || ''"
                               v-on:blur="ownPastLossOfEarningsFigure = ownPastLossOfEarningsFigure || 0"
                               type="text"
                               name="ownPastLossOfEarningsFigure"
                               min="0.00"
                               v-two-dp
                               v-field-control:ownPastLossOfEarningsFigure.valid="{type:'number', rules:'valid'}">
                        <control-error :show="$error('ownPastLossOfEarningsFigure')">
                            Your own past loss of earnings figure should be greater than &pound;0.00
                        </control-error>
                    </control>
                    <div v-for="index in pastLossOfEarningsPeriods.length" v-if="pastLossOfEarningsType === 'manual'">
                        <earnings-period @update="updateValid()" :index="index - 1"></earnings-period>
                    </div>
                    <button class="a-button a-button--no-margin"
                            v-if="pastLossOfEarningsPeriods.length >= 0 && pastLossOfEarningsType === 'manual'"
                            @click="addLossOfEarningsPeriod"
                            style="margin-bottom: 40px;">
                        Add Period
                    </button>
                    <control for="past_loss_of_earnings"
                             label="Past Loss of Earnings Total"
                             before-after="pound">
                        <input autocomplete="off" 
                              :value="currencyFormat(findValue('pastLossOfEarnings'), '')"
                               type="text"
                               disabled>
                    </control>
                    <hr>
                    <br>
                    <control label="Care"
                             tip-text="You have three options to assess the care claim — click the help icon to find out more."
                             tip-icon="info"
                             tip-side="left"
                             tip-width="200"
                             tip-name="care"
                             modalName="careModal">
                        <select id="careCalcType" v-model="careCalcType" required>
                            <option value="" disabled hidden>Please select...</option>
                            <option value="own">Enter your own figure</option>
                            <option value="auto">Auto-calculate</option>
                            <option value="manual">Detailed calculation</option>
                        </select>
                    </control>
                    <control for="ownCareFigure" v-if="careCalcType === 'own'" label="Enter Your Own Figure"
                             before-after="pound">
                        <input autocomplete="off"
                               v-model.number="ownCareFigure"
                               v-on:focus="ownCareFigure = ownCareFigure || ''"
                               v-on:blur="ownCareFigure = ownCareFigure || 0"
                               type="text"
                               name="ownCareFigure"
                               min="0.00"
                               v-two-dp
                               v-field-control:ownCareFigure.valid="{type:'number', rules:'valid'}">
                        <control-error :show="$error('ownCareFigure')">
                            Your own care figure should be greater than &pound;0.00
                        </control-error>
                    </control>
                    <div v-for="index in periods.length" v-if="careCalcType === 'manual'">
                        <care-period @update="updateValid()" :index="index - 1"></care-period>
                    </div>
                    <button class="a-button a-button--no-margin"
                            v-if="periods.length >= 0 && careCalcType === 'manual'"
                            @click="addCarePeriod"
                            style="margin-bottom: 40px;">
                        Add Period
                    </button>
                    <div :class="{ 'a-loader--care' : loading }"></div>
                    <div v-if="!loading">
                        <control for="care_total" label="Care Total"
                                 before-after="pound"
                                 :tip-icon="careIcon"
                                 :tip-show="careCalcType === 'auto'"
                                 tip-text="Click to view calculation" tip-side="left"
                                 tip-width="140"
                                 tip-name="care_total"
                                 :modal-name="'headsOfLoss_' + uniqueId"
                                 :endpoint="'autoCare'">
                            <input autocomplete="off" :value="currencyFormat(findValue('pastCostOfCare'), '')" type="text"
                                   disabled>
                        </control>
                    </div>
                </div>
            </form>
        </div>

        <step-button :next-valid="isValid()"></step-button>

        <modal name="pastLossOfEarningsModal" no-default-button="true">
            <h2>
                Past Loss of Earnings Claim Options
            </h2>
            <p>
                You have two options to assess the care claim:<br>
            </p>
            <ul class="u-margin-lr-40">
                <li class="u-margin-bottom-20">
                    You can simply enter in a £ sum for the known past loss of earnings.
                </li>
                <li class="u-margin-bottom-20">
                    You can carry out a detailed calculation looking at differing periods and calculating from either Net or Gross income per annum.
                </li>
            </ul>
        </modal>

        <modal name="careModal" no-default-button="true">
            <h2>
                Care Claim Options
            </h2>
            <p>
                You have three options to assess the care claim:<br>
            </p>
            <ul class="u-margin-lr-40">
                <li class="u-margin-bottom-20">
                    You can simply enter in a £ sum for the care.
                </li>
                <li class="u-margin-bottom-20">
                    You can Auto-calculate the award. The CA in Rothwell v Chemical Insulating Co. Ltd [2006] EWCA Civ 27 recognised a sum of £12,500 as the norm for care in claims for terminal malignant mesothelioma. This award is inflated to today’s value applying the Retail Price Index since January 2006.
                </li>
                <li class="u-margin-bottom-20">
                    You can carry out a detailed calculation looking at differing periods and differing hours of care and applying either a basic or aggregate care rate valued according to Local Authority Spinal Point 8. You can then discount the claim by 25% to reflect the gratuitous rather than commercial nature of the care.
                </li>
            </ul>
        </modal>

        <modal :name="'headsOfLoss_' + uniqueId" no-default-button="true">
            <modal-content></modal-content>
        </modal>

        <modal name="generalDamagesPslaModal" no-default-button="true">
            <general-damages-psla-calculator v-if="modals.generalDamagesPslaModal"></general-damages-psla-calculator>
        </modal>

        <modal name="lossOfSpouse" no-default-button="true">
            <h2>
                Loss of Spouse
            </h2>

            <p>
                Also known as ‘Regan Awards’ and awards for ‘loss of intangible benefits’, this head of loss is usually claimed for the loss of services provided by a spouse/parent which go beyond what can be commercially sourced e.g. care and attention. Originally established in Regan v Williamson, we discussed the most recent case law in <a
                    href="https://www.bc-legal.co.uk/images/pdf/177-BC-Disease-News-2017-03-17-Edition-177.pdf"
                    target="_blank">Edition 177 of BC Disease News</a>.
            </p>
        </modal>

    </div>
</template>

<script>
    import _ from 'lodash';
    import currencyFormat from 'mixins/currencyFormat';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import FormValidator from 'components/form/validator/mixin';
    import Modal from 'components/modal/Modal.vue';
    import StepButton from 'components/StepButton.vue';
    import HeadOfLoss from 'pages/fatal-accident-claims/dependency/steps/heads-of-loss/HeadOfLoss.vue';
    import CarePeriod from 'pages/fatal-accident-claims/dependency/steps/heads-of-loss/CarePeriod.vue';
    import EarningsPeriod from 'pages/fatal-accident-claims/dependency/steps/heads-of-loss/EarningsPeriod.vue';
    import {mapGetters, mapActions} from 'vuex';
    import {setStepValid} from 'services/routingMethods';
    import ModalContent from 'components/modal/ModalContent.vue';
    import {isStepValid} from 'services/routingMethods';
    import GeneralDamagesPslaCalculator from 'pages/fatal-accident-claims/dependency/steps/general-damages/GeneralDamagesPslaCalculator';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        components: {
            Control,
            ControlError,
            StepButton,
            HeadOfLoss,
            CarePeriod,
            EarningsPeriod,
            Modal,
            ModalContent,
            GeneralDamagesPslaCalculator
        },
        mixins: [
            FormValidator,
            currencyFormat
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        watch: {
            'generalDamages'(newVal, oldValue) {
                 this.$nextTick(() => {
                    this.updateValid()
                });
            }
        },
        data() {
            return {
                loading: false
            }
        },
        created() {
            this.updateValid();
            this.determineBereavementAward();
        },
        mounted() {
            this.updatePastDependencyOnServices();
            this.updateValid();
        },
        computed: {
            ...mapGetters('fatal/dependency/headsOfLoss', {
                findValue: 'value',
                headsOfLoss: 'headsOfLoss',
                allHeadsOfLossValid: 'allHeadsOfLossValid',
                periods: 'periods',
                pastLossOfEarningsPeriods: 'pastLossOfEarningsPeriods',
                allPeriodsValid: 'allPeriodsValid',
                pastLossOfEarningsPeriodsValid: 'pastLossOfEarningsPeriodsValid',
            }),
            ...mapGetters('fatal/dependency/claimDetails', {
                claimValue: 'value',
            }),
            ...mapGetters('modal', ['modals']),
            ...mapGetters('fatal/dependency/deceased', [
                'theDeceased',
            ]),
            diseaseType: {
                get() {
                    return this.claimValue('diseaseType')
                },
            },
            generalDamages: {
                get() {
                    return this.findValue('generalDamages')
                },
                set(value) {
                    this.updateValue({key: 'generalDamages', value: value}).then(this.updateValid);
                }
            },
            funeralExpenses: {
                get() {
                    return this.findValue('funeralExpenses')
                },
                set(value) {
                    this.updateValue({key: 'funeralExpenses', value: value}).then(this.updateValid);
                }
            },
            lossOfSpouse: {
                get() {
                    return this.findValue('lossOfSpouse')
                },
                set(value) {
                    this.updateValue({key: 'lossOfSpouse', value: value}).then(this.updateValid);
                }
            },
            pastLossOfEarnings: {
                get() {
                    return this.findValue('pastLossOfEarnings')
                },
                set(value) {
                    this.updateValue({key: 'pastLossOfEarnings', value: value}).then(this.updateValid);
                }
            },
            pastCostOfTravel: {
                get() {
                    return this.findValue('pastCostOfTravel')
                },
                set(value) {
                    this.updateValue({key: 'pastCostOfTravel', value: value}).then(this.updateValid);
                }
            },
            misc: {
                get() {
                    return this.findValue('misc')
                },
                set(value) {
                    this.updateValue({key: 'misc', value: value}).then(this.updateValid);
                }
            },
            careCalcType: {
                get() {
                    return this.findValue('careCalcType')
                },
                set(value) {
                    this.updateValue({key: 'careCalcType', value})
                        .then(this.updateValid);

                    if (value !== 'own') {
                        this.updateValue({
                            key: 'ownCareFigure',
                            value: this.ownCareFigure || 0
                        });

                        if (!this.periods.length) {
                            this.addCarePeriod();
                        }
                    }

                    if (value === 'auto') {
                        this.loading = true;

                        return this.autoCalculateCare(this.findValue('gratuitousCare')).then(() => {
                            this.loading = false;
                        })
                    }

                    return this.updateValue({
                        key: 'pastCostOfCare',
                        value: 0
                    });
                }
            },
            pastLossOfEarningsType: {
                get() {
                    return this.findValue('pastLossOfEarningsType')
                },
                set(value) {
                    this.updateValue({key: 'pastLossOfEarningsType', value})
                        .then(this.updateValid);
                    if (value !== 'own') {
                        this.updateValue({
                            key: 'pastLossOfEarningsType',
                            value: this.pastLossOfEarningsType || 0
                        });

                        if (!this.pastLossOfEarningsPeriods.length) {
                            this.addLossOfEarningsPeriod();
                        }
                    }
                    return this.updateValue({
                        key: 'pastLossOfEarnings',
                        value: 0
                    });
                }
            },
            gratuitousCare: {
                get() {
                    return this.findValue('gratuitousCare')
                },
                set(value) {
                    this.updateValue({key: 'gratuitousCare', value}).then(this.updateValid);
                    this.determineCalculateCare(value);
                }
            },
            ownCareFigure: {
                get() {
                    return this.findValue('ownCareFigure')
                },
                set(value) {
                    if (isNaN(value)) {
                        value = 0;
                    }
                    this.updateValue({key: 'ownCareFigure', value}).then(this.updateValid);
                    this.ownCalculateCare(this.findValue('gratuitousCare'))
                }
            },
            ownPastLossOfEarningsFigure: {
                get() {
                    return this.findValue('ownPastLossOfEarningsFigure')
                },
                set(value) {
                    if (isNaN(value)) {
                        value = 0;
                    }
                    this.updateValue({key: 'ownPastLossOfEarningsFigure', value});
                    this.updateValue({key: 'pastLossOfEarnings', value}).then(this.updateValid);
                }
            },
            careIcon: {
                get() {
                    return (this.findValue('careCalcType') === 'auto') ? 'formula' : 'default';
                }
            },
            bereavementModalPayload() {
                return {
                    person: this.theDeceased,
                }
            },
            uniqueId() {
                return this._uid;
            },
        },
        methods: {
            ...mapActions('fatal/dependency/headsOfLoss', {
                updateValue: 'updateValue',
                calcInterest: 'calcAllInterest',
                addHeadOfLoss: 'addHeadOfLoss',
                addCarePeriod: 'addCarePeriod',
                addLossOfEarningsPeriod: 'addLossOfEarningsPeriod',
                autoCalculateCare: 'autoCalculateCare',
                ownCalculateCare: 'ownCalculateCare',
                determineBereavementAward: 'determineBereavementAward',
                updatePastDependencyOnServices: 'updatePastDependencyOnServices'
            }),
            ...mapActions('modal', ['toggle']),
            calcInterestValue() {
                if (isStepValid(6)) {
                    this.calcInterest();
                }
            },
            determineCalculateCare(value) {
                if (this.findValue('careCalcType') === 'auto') {
                    this.autoCalculateCare(value)
                } else if (this.findValue('careCalcType') === 'own') {
                    this.ownCalculateCare(value)
                }
            },
            updateValid() {
                if (this.careCalcType === 'auto' || this.careCalcType === 'own') {
                    this.validCare = this.allHeadsOfLossValid;
                }

                if (this.careCalcType === 'manual') {
                    this.validCare = (this.allHeadsOfLossValid && this.allPeriodsValid);
                }

                if (this.pastLossOfEarningsType === 'manual') {
                    this.validPassLossOfEarnings = this.pastLossOfEarningsPeriodsValid;
                }

                if (this.pastLossOfEarningsType === 'own' ) {
                    this.validPassLossOfEarnings = (this.ownPastLossOfEarningsFigure !== null && this.ownPastLossOfEarningsFigure !== "");
                }

                setStepValid(this.$valid() && this.validCare && this.validPassLossOfEarnings);
            },
            isValid() {
                return isStepValid(6);
            },
            toggleGeneralDamagesPslaModal() {
                this.toggle('generalDamagesPslaModal');
            },
            addNewHeadOfLoss() {
                this.addHeadOfLoss();
                this.updateValid();
            },
        }
    }
</script>


// WEBPACK FOOTER //
// HeadsOfLossAndDependency.vue?39294522